import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Refresh = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14.6667 5.57199C13.8639 5.33799 12.9781 5.18499 12 5.18499C7.58016 5.18499 4 8.67699 4 12.988C4 17.308 7.58016 20.8 12 20.8C16.4198 20.8 20 17.308 20 12.997C20 11.395 19.5017 9.90099 18.6528 8.65899M13.1442 2.79999L15.8108 5.78799L12.7013 8.00199",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
